import { Tabs as AntdTabs } from 'antd';
import styles from './Tabs.module.scss';

const Tabs = ({
  tabsList = [],
  tabStyle = {},
  defaultActiveKey = '0',
  activeKey,
  tabPosition = 'top',
  onTabClick = () => {},
  contentClassName = '',
  defaultTabBarExtraContent = () => {},
  getAction = () => {},
  containerClassName = '',
  className = '',
  ...props
}) => {
  const currentKey = activeKey ?? defaultActiveKey;

  const tabBarExtraContent = () => {
    const selectedTab = tabsList.find((tab) => tab.key == currentKey);
    if (selectedTab) {
      return <>{getAction(selectedTab) ?? defaultTabBarExtraContent()}</>;
    }
    return defaultTabBarExtraContent();
  };

  const renderTabBar = (props, DefaultTabBar) => (
    <div className={`${styles.tabsContainer} ${containerClassName}`}>
      <DefaultTabBar {...props} />
    </div>
  );

  return (
    <AntdTabs
      {...(activeKey !== undefined ? { activeKey: String(activeKey) } : { defaultActiveKey: String(defaultActiveKey) })}
      style={tabStyle}
      tabPosition={tabPosition}
      onTabClick={onTabClick}
      tabBarExtraContent={tabBarExtraContent()}
      renderTabBar={renderTabBar}
      className={className}
      items={tabsList
        ?.filter((item) => item?.show)
        ?.map((tab) => {
          return {
            label: tab.label,
            key: String(tab.key),
            children: <div className={contentClassName}>{tab.children}</div>,
          };
        })}
      {...props}
    />
  );
};

export default Tabs;
